import BackSvgComponent from "assets/icons/svg/back";
import TrippleSvgComponent from "assets/icons/svg/drop";
import InfoTooltip from "components/InfoTooltip";
import SearchBar from "components/Search";
import * as _ from "lodash";
import React from 'react';
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const OrderFieldsDetails = ({
  searchTerm,
  setSearchTerm,
  parameter,
  filters,
  onDragEnd,
  removeFilter,
  handleClick
}) => {
  return (
    <div className="details">
    <div className="parameter">
      <div className="parameter-form">
        <div className="parameter-head d-flex align-items-center">
          PARAMETERS
          <InfoTooltip text="Click a field here to add it as a column in this segment's output. Fields already added are hidden from this list." placement="bottom" useFixed style={{ marginLeft: '6px' }} />
        </div>
        <div className="filter-search-bar">
          <SearchBar searchTerm={searchTerm} setValue={setSearchTerm} />
        </div>
        <div>
          {parameter?.map((item, index) => {
            return (
              <div className="member-search" key={index}>
                <div className="member-head">
                  {item?.collectionDisplayName}
                </div>
                <div className="search-items">
                  {item?.fieldsGroup
                    .filter(
                      (value) =>
                        value.displayName
                          .toLowerCase()
                          .includes(searchTerm.toLowerCase()) &&
                        !_.find(
                          filters,
                          (item) => item.displayName === value.displayName
                        )
                    )
                    .map((data, index) => {
                      return (
                        <div
                          key={index}
                          className={`search-options ${data.displayName in filters ? "active" : ""
                            }`}
                          onClick={() => handleClick(data, item)}
                        >
                          {data?.displayName}
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
    <div className="vallues">
      <div className="parameter-form">
        <div className="parameter-head d-flex align-items-center">
          ORDER
          <InfoTooltip text="Drag fields up or down to set the column order in this segment's results and exports." placement="bottom" useFixed style={{ marginLeft: '6px' }} />
        </div>
        {!filters?.length ? (
          <div className="choose-parameter-text">
            <span>Please choose from the</span>
            <span>Parameters in the left box</span>
          </div>
        ) : (
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {filters.map((filter, index) => (
                    <Draggable
                      key={`filter${index}`}
                      draggableId={`filter${index}`}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          className="parameter-value"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <div className="order-value-options">
                            <div className="svg-drag">
                              <div className="drag-svg">
                                <TrippleSvgComponent />
                              </div>
                              <div className="filter-key">
                                {filter.displayName}
                              </div>
                            </div>
                          </div>
                          <div className="back-button">
                            <BackSvgComponent
                              onClick={() => removeFilter(filter.fieldName)}
                            />
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}

                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        )}
      </div>
    </div>
  </div>
  )
}

export default OrderFieldsDetails